module.exports = __webpack_public_path__ + "d.no2.2ed545bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/d.no2.jpg
// module id = c71S
// module chunks = 0